import { useEffect } from 'react';

/**
 * Custom hook to set page title dynamically
 * @param {string} title - The page title
 */
export function usePageTitle(title) {
  useEffect(() => {
    const defaultTitle = 'Southeast Asia Luxury Yachts – Superyachts, Catamarans & Charters';
    document.title = title ? `${title} | Southeast Asia Luxury Yachts` : defaultTitle;
    
    return () => {
      document.title = defaultTitle;
    };
  }, [title]);
}
